import {ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DialogProps} from '../dialogs/dialog';

/*
 * Constants.
 */

export const frameBannerWidth = 280;

/*
 * Props.
 */

export interface FrameProps extends Omit<DialogProps, 'onRequestClose'> {
  width: number;
  shouldForcePopout?: boolean;
  onRequestClose: (forceClose: boolean) => void;
  onOpenPopout?: Handler;
  startHeight?: number;
  shouldHideDialogHeader?: boolean;
  children: ReactNode;
}

/*
 * Style.
 */

interface FrameStyleProps {
  $minWidth?: string;
  $minHeight?: string;
  $maxHeight?: string;
}
export const StyledFrameDiv = styled.div<FrameStyleProps>`
  display: flex;
  flex-direction: column;

  height: 100%;
  ${(p) => p.$minWidth && `min-width: ${p.$minWidth}`};
  ${(p) => p.$minHeight && `min-height: ${p.$minHeight}`};
  ${(p) => p.$maxHeight && `max-height: ${p.$maxHeight}`};

  background-color: ${(p) => p.theme.foreground};
`;

export const StyledFrameBannersDiv = styled.div`
  position: absolute;
  height: 100%;
  padding: 16px 10px 76px 10px;

  display: flex;
  align-items: stretch;
  pointer-events: none;
`;
